var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import PropTypes from "prop-types";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { ResponsiveProp, isWidthTokenProp, isMinWidthTokenProp, isMaxWidthTokenProp, isHeightTokenProp, isMinHeightTokenProp, isMaxHeightTokenProp, isPaddingTokenProp, isMarginTokenProp } from "@twilio-paste/style-props";
var getGrow = _ref => {
    let {
      grow
    } = _ref;
    return Array.isArray(grow) ? grow.map(value => Number(value)) : typeof grow == "number" ? grow : grow ? 1 : 0;
  },
  getShrink = _ref2 => {
    let {
      shrink,
      basis
    } = _ref2;
    return Array.isArray(shrink) ? shrink.map(value => Number(value)) : typeof shrink == "number" ? shrink : typeof shrink == "boolean" ? shrink ? 1 : 0 : basis && basis !== "auto" ? 0 : 1;
  },
  getSuffix = item => {
    let suffix = typeof item == "number" || String(Number.parseInt(item, 10)) === item ? "px" : "";
    return item + suffix;
  },
  getBasis = _ref3 => {
    let {
      basis
    } = _ref3;
    return Array.isArray(basis) ? basis.map(value => getSuffix(value)) : basis ? getSuffix(basis) : "auto";
  },
  getVertical = _ref4 => {
    let {
      vertical
    } = _ref4;
    return Array.isArray(vertical) ? vertical.map(value => typeof value == "boolean" ? value === !0 ? "column" : "row" : value) : vertical ? "column" : "row";
  },
  getWrap = _ref5 => {
    let {
      wrap
    } = _ref5;
    return Array.isArray(wrap) ? wrap.map(value => typeof value == "boolean" ? value === !0 ? "wrap" : "nowrap" : value) : wrap ? "wrap" : "nowrap";
  },
  RemapedVerticalAlignments = {
    top: "flex-start",
    center: "center",
    bottom: "flex-end",
    stretch: "stretch"
  },
  vAlignToProps = _ref6 => {
    let {
      vAlignContent
    } = _ref6;
    return Array.isArray(vAlignContent) ? vAlignContent.map(value => RemapedVerticalAlignments[value]) : vAlignContent ? RemapedVerticalAlignments[vAlignContent] : "flex-start";
  },
  RemapedHorizontalAlignments = {
    left: "flex-start",
    center: "center",
    right: "flex-end",
    around: "space-around",
    between: "space-between"
  },
  hAlignToProps = _ref7 => {
    let {
      hAlignContent
    } = _ref7;
    return Array.isArray(hAlignContent) ? hAlignContent.map(value => RemapedHorizontalAlignments[value]) : hAlignContent ? RemapedHorizontalAlignments[hAlignContent] : "flex-start";
  };
var getFlexStyles = props => {
    let styles = {
      justifyContent: props.vertical ? vAlignToProps(props) : hAlignToProps(props),
      alignItems: props.vertical ? hAlignToProps(props) : vAlignToProps(props)
    };
    return (props.grow || props.shrink || props.basis) && (styles.flexGrow = getGrow(props), styles.flexShrink = getShrink(props), styles.flexBasis = getBasis(props)), props.vertical && (styles.flexDirection = getVertical(props)), props.wrap && (styles.flexWrap = getWrap(props)), styles;
  },
  Flex = React.forwardRef((_a, ref) => {
    var _b = _a,
      {
        as,
        basis,
        children,
        display,
        element = "FLEX",
        hAlignContent,
        grow,
        marginTop,
        marginRight,
        marginBottom,
        marginLeft,
        margin,
        marginX,
        marginY,
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        padding,
        paddingX,
        paddingY,
        maxWidth,
        minWidth = "size0",
        width,
        height,
        minHeight,
        maxHeight,
        size,
        shrink,
        vertical,
        vAlignContent,
        wrap
      } = _b,
      props = __objRest(_b, ["as", "basis", "children", "display", "element", "hAlignContent", "grow", "marginTop", "marginRight", "marginBottom", "marginLeft", "margin", "marginX", "marginY", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "padding", "paddingX", "paddingY", "maxWidth", "minWidth", "width", "height", "minHeight", "maxHeight", "size", "shrink", "vertical", "vAlignContent", "wrap"]);
    let FlexStyles = React.useMemo(() => getFlexStyles({
      basis,
      hAlignContent,
      grow,
      shrink,
      vertical,
      vAlignContent,
      wrap
    }), [basis, hAlignContent, grow, shrink, vertical, vAlignContent, wrap]);
    size && (width || height) && console.error("[Paste Flex]: you cannot set a height or width when using the size attribute"), (marginX && (margin || marginBottom || marginLeft || marginRight || marginTop) || marginY && (margin || marginBottom || marginLeft || marginRight || marginTop)) && console.error("[Paste Flex]: you cannot set a top, right, bottom or left margin when using the marginX or marginY attributes."), (paddingX && (padding || paddingBottom || paddingLeft || paddingRight || paddingTop) || paddingY && (padding || paddingBottom || paddingLeft || paddingRight || paddingTop)) && console.error("[Paste Flex]: you cannot set a top, right, bottom or left padding when using the paddingX or paddingY attributes.");
    let margins = marginX || marginY ? {
        marginX,
        marginY
      } : {
        margin,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop
      },
      paddings = paddingX || paddingY ? {
        paddingX,
        paddingY
      } : {
        padding,
        paddingBottom,
        paddingLeft,
        paddingRight,
        paddingTop
      },
      widths = size ? {
        size
      } : {
        height,
        width
      };
    return React.createElement(Box, __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues({}, FlexStyles), safelySpreadBoxProps(props)), {
      ref,
      as,
      display,
      element
    }), margins), paddings), {
      minHeight,
      maxHeight,
      maxWidth,
      minWidth
    }), widths), children);
  });
Flex.displayName = "Flex";
Flex.defaultProps = {
  display: "flex"
};
Flex.propTypes = {
  as: PropTypes.string,
  display: ResponsiveProp(PropTypes.oneOf(["flex", "inline-flex"])),
  element: PropTypes.string,
  vertical: ResponsiveProp(PropTypes.bool),
  vAlignContent: ResponsiveProp(PropTypes.oneOf(["top", "center", "bottom", "stretch"])),
  hAlignContent: ResponsiveProp(PropTypes.oneOf(["left", "center", "right", "around", "between"])),
  grow: ResponsiveProp(PropTypes.oneOfType([PropTypes.bool, PropTypes.number])),
  shrink: ResponsiveProp(PropTypes.oneOfType([PropTypes.bool, PropTypes.number])),
  basis: ResponsiveProp(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  wrap: ResponsiveProp(PropTypes.bool),
  width: isWidthTokenProp,
  minWidth: isMinWidthTokenProp,
  maxWidth: isMaxWidthTokenProp,
  height: isHeightTokenProp,
  minHeight: isMinHeightTokenProp,
  maxHeight: isMaxHeightTokenProp,
  size: isWidthTokenProp,
  margin: isMarginTokenProp,
  marginTop: isMarginTokenProp,
  marginRight: isMarginTokenProp,
  marginBottom: isMarginTokenProp,
  marginLeft: isMarginTokenProp,
  marginX: isMarginTokenProp,
  marginY: isMarginTokenProp,
  padding: isPaddingTokenProp,
  paddingTop: isPaddingTokenProp,
  paddingRight: isPaddingTokenProp,
  paddingBottom: isPaddingTokenProp,
  paddingLeft: isPaddingTokenProp,
  paddingX: isPaddingTokenProp,
  paddingY: isPaddingTokenProp
};
export { Flex };